<template>
  <div>
    <div class="contents">
      <b-form @submit="onSubmit">
        <div class="mb-3">
          <button type="button" class="btn btn-primary" @click="addForm">
            +
          </button>
        </div>

        <div
          v-for="(item, idx) in form"
          :key="idx"
          class="mb-4 border p-3 position-relative"
        >
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0 fw-bold">Main Banner {{ idx + 1 }}</h6>
            <button
              type="button"
              class="btn btn-danger btn-sm text-white"
              @click="removeForm(idx)"
            >
              <span class="material-icons-outlined" style="font-size: 18px"
                >close</span
              >
            </button>
          </div>

          <div class="row g-0 table-type header-col">
            <div class="col-sm-4">{{ $t("title.common.display") }}</div>
            <div class="col-sm-8">
              <b-form-checkbox
                v-model="form[idx].display_flag"
                name="check-button"
                size="lg"
                switch
              />
            </div>

            <div class="col-sm-4">{{ $t("title.common.title") }}</div>
            <div class="col-sm-8">
              <input type="text" v-model="form[idx].mb_title" />
            </div>

            <div class="col-sm-4">{{ $t("title.common.sub_title") }}</div>
            <div class="col-sm-8">
              <input type="text" v-model="form[idx].mb_sub_title" />
            </div>

            <div class="col-sm-4">{{ $t("title.common.description") }}</div>
            <div class="col-sm-8">
              <input type="text" v-model="form[idx].mb_description" />
            </div>

            <div class="col-sm-4">Location</div>
            <div class="col-sm-8">
              <input type="text" v-model="form[idx].mb_link" />
            </div>

            <div class="col-sm-4">{{ $t("title.common.image") }}</div>
            <div class="col-sm-8 d-block">
              <div class="d-flex flex-column flex-sm-row flex-grow-1">
                <div class="flex-shrink-0 me-0 me-sm-2 mb-2 mb-sm-0">
                  <img
                    :src="form[idx] && form[idx].filepath | get_img"
                    class="avatar avatar-lg rounded-0"
                  />
                </div>
                <div class="flex-grow-1">
                  <b-form-file
                    v-model="file[idx]"
                    :ref="'file_' + idx"
                    :state="Boolean(file[idx])"
                    :placeholder="$t('text.tournament.select_file_or_drop')"
                    :drop-placeholder="$t('text.tournament.drop_it_here')"
                    @change="fileSelect($event, idx)"
                  />
                </div>
              </div>

              <a
                class="d-block mt-2 text-subscript more"
                href="/img/Tournament.Banner.Guidelines.v1.pdf?v=1.1.6"
                target="_blank"
              >
                <span class="material-icons-outlined">info</span>
                {{ $t("text.common.tournament_banner_guidelines") }}
              </a>
            </div>
          </div>
        </div>

        <div class="btn-bottom-wrapper">
          <b-button
            size="xl"
            variant="primary"
            type="submit"
            :aria-label="$t('button.common.save')"
            >{{ $t("button.common.save") }}</b-button
          >
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import ax from "@/api/manager";
import "@/filter/common";

export default {
  name: "BannerWrite",
  data() {
    return {
      form: [],
      file: [],
    };
  },
  methods: {
    emptyForm() {
      return {
        mb_pk: 0,
        mb_title: "",
        mb_sub_title: "",
        mb_description: "",
        mb_link: "",
        filepath: "",
        display_flag: true,
        filename: "",
      };
    },

    addForm() {
      this.form.push(this.emptyForm());
      this.file.push(null);
    },

    removeForm(idx) {
      if (this.form.length === 1) {
        alert("There must be at least one.");
        return;
      }
      this.form.splice(idx, 1);
      this.file.splice(idx, 1);
    },

    fileSelect(e, idx) {
      const selectedFile = e.dataTransfer
        ? e.dataTransfer.files[0]
        : e.target.files[0];

      this.$set(this.form[idx], "filename", selectedFile);
      this.$set(this.file, idx, selectedFile);
    },

    onSubmit(event) {
      event.preventDefault();

      for (let i = 0; i < this.form.length; i++) {
        if (!this.form[i].mb_title) {
          alert(
            this.$i18n.t("alert.common.field_required", {
              field: this.$i18n.t("title.common.title"),
            }),
          );
          a;
          return false;
        }
        if (!this.file[i] && !this.form[i].filepath) {
          alert(
            this.$i18n.t("alert.common.field_required", {
              field: this.$i18n.t("title.common.image"),
            }),
          );
          return false;
        }
      }

      ax.post_bannerwrite(this.form, (flag, data) => {
        alert(data.message);
        if (flag) {
          this.get_bannerlist();
        }
      });
    },

    get_bannerlist() {
      ax.get_bannerlist((flag, data) => {
        if (flag) {
          this.form = data.list.map((item) => ({
            ...item,
            display_flag: item.display_flag === "1",
          }));
          this.file = new Array(data.list.length).fill(null);

          if (this.form.length === 0) {
            this.form = [this.emptyForm(), this.emptyForm(), this.emptyForm()];
            this.file = [null, null, null];
          }
        }
      });
    },
  },
  created() {
    this.get_bannerlist();
  },
};
</script>
